import React from "react";
import MainNav1 from "./MainNav1";

const Header2 = () => {
  return (
    <div className="nc-Header2 sticky top-0 w-full z-40">
      <MainNav1 />
    </div>
  );
};

export default Header2;
